import type { AddressProviderTreeNode, LogChunk } from "@shared/types";
import { NodeStatus } from "@shared/types";

enum LogLevel {
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
  DEBUG = "DEBUG",
}

export interface LogEntry {
  id?: string;
  level: LogLevel;
  timestamp: string;
  message: string;
  jobId?: string;
  key?: string;
  params?: Record<string, string | number>;
}

export interface TreeNode {
  id: string;
  name: string;
  status: NodeStatus;
  timestamp: string;
  children?: TreeNode[];
  entries?: LogEntry[];
}

export interface LiveLogTreeProps {
  initialAddresses?: AddressProviderTreeNode[];
  rawLogs?: LogChunk[];
  className?: string;
}

export interface AddressNodeProps {
  addressName: string;
  status: NodeStatus;
  label: string;
  entries?: LogEntry[];
  providers: Array<{
    id: string;
    name: string;
    status: NodeStatus;
    label: string;
    entries?: LogEntry[];
  }>;
}

export interface AddressNodeData {
  addressName: string;
  status: NodeStatus;
  label: string;
  entries?: LogEntry[];
  providers: Array<{
    id: string;
    name: string;
    status: NodeStatus;
    label: string;
    entries?: LogEntry[];
  }>;
}

export { LogLevel };
